module.exports = __webpack_public_path__ + "static/media/Iran.fcdb0efb.png";